import React from 'react'
import { Brain, Shield, Zap } from 'lucide-react'

const InsightsSection: React.FC = () => {
  return (
    <section id="insights" className="py-20" style={{ backgroundColor: 'var(--card)' }}>
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-3xl font-light mb-12" style={{ color: 'var(--primary)' }}>
          Latest Insights
        </h2>
        <p className="text-lg mb-16" style={{ color: 'var(--text-muted)' }}>
          Coming soon - thoughts on the future of intelligent software
        </p>
        
        <div className="grid md:grid-cols-3 gap-12">
          <div className="insight-item">
            <div className="w-16 h-16 insight-icon rounded-full flex items-center justify-center mx-auto mb-4">
              <Brain className="w-8 h-8" style={{ color: 'var(--primary)' }} />
            </div>
            <h3 className="font-medium mb-2" style={{ color: 'var(--primary)' }}>
              How AI shapes resilient software
            </h3>
            <p className="text-sm mb-4" style={{ color: 'var(--text-muted)' }}>
              Exploring intelligence in development
            </p>
            <span className="text-sm font-medium" style={{ color: 'var(--accent)' }}>
              Coming Soon
            </span>
          </div>
          
          <div className="insight-item">
            <div className="w-16 h-16 insight-icon rounded-full flex items-center justify-center mx-auto mb-4">
              <Shield className="w-8 h-8" style={{ color: 'var(--primary)' }} />
            </div>
            <h3 className="font-medium mb-2" style={{ color: 'var(--primary)' }}>
              Security strategies for cloud-first
            </h3>
            <p className="text-sm mb-4" style={{ color: 'var(--text-muted)' }}>
              Best practices for protection
            </p>
            <span className="text-sm font-medium" style={{ color: 'var(--accent)' }}>
              Coming Soon
            </span>
          </div>
          
          <div className="insight-item">
            <div className="w-16 h-16 insight-icon rounded-full flex items-center justify-center mx-auto mb-4">
              <Zap className="w-8 h-8" style={{ color: 'var(--primary)' }} />
            </div>
            <h3 className="font-medium mb-2" style={{ color: 'var(--primary)' }}>
              Developer efficiency with automation
            </h3>
            <p className="text-sm mb-4" style={{ color: 'var(--text-muted)' }}>
              Tools for team productivity
            </p>
            <span className="text-sm font-medium" style={{ color: 'var(--accent)' }}>
              Coming Soon
            </span>
          </div>
        </div>
      </div>
    </section>
  )
}

export default InsightsSection